import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Box,
  Button,
  Typography,
} from "@mui/material";
import image from "../../image/hashtag-polaroid.jpg";

export function ConfirmPrintPopup({ open, onClose, onConfirm }) {
  return (
    <Dialog open={open} fullWidth maxWidth="xs">
      <DialogTitle
        sx={{ display: "flex", justifyContent: "center", alignItems: "center" }}
      >
        Confirmation d'impression
      </DialogTitle>

      <DialogContent sx={{ textAlign: "center" }}>
        <Typography>Souhaitez-vous imprimer cette image ?</Typography>
      </DialogContent>

      <DialogActions sx={{ justifyContent: "right" }}>
        <Button variant="outlined" color="error" onClick={onClose}>
          Annuler
        </Button>
        <Button
          variant="contained"
          color="primary"
          onClick={onConfirm}
          sx={{ marginLeft: 2 }}
        >
          Imprimer
        </Button>
  
      </DialogActions>
    </Dialog>
  );
}
